import { useEffect, useState } from 'react'
import Modal from '../../components/UI/Modal'
import { apiService } from '../../services/api'

const Connections = () => {
	const [connections, setConnections] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState('')
	const [showModal, setShowModal] = useState(false)
	const [editingConnection, setEditingConnection] = useState(null)
	const [connectionForm, setConnectionForm] = useState({
		name: '',
		db_type: '',
		host: '',
		port: '',
		database_name: '',
		username: '',
		password: '',
		description: '',
	})

	useEffect(() => {
		loadConnections()
	}, [])

	const loadConnections = async () => {
		try {
			setLoading(true)
			setError('')
			const data = await apiService.getConnections()
			setConnections(data)
		} catch (err) {
			console.error('Failed to load connections:', err)
			setError('Ошибка при загрузке подключений')
		} finally {
			setLoading(false)
		}
	}

	const handleAddConnection = () => {
		setEditingConnection(null)
		setConnectionForm({
			name: '',
			db_type: '',
			host: '',
			port: '',
			database_name: '',
			username: '',
			password: '',
			description: '',
		})
		setShowModal(true)
	}

	const handleEditConnection = connection => {
		setEditingConnection(connection)
		setConnectionForm({
			name: connection.name,
			db_type: connection.db_type,
			host: connection.host,
			port: connection.port || '',
			database_name: connection.database_name,
			username: connection.username,
			password: '', // Пароль не показываем
			description: connection.description || '',
		})
		setShowModal(true)
	}

	const handleSaveConnection = async e => {
		e.preventDefault()

		try {
			setError('')

			if (editingConnection) {
				await apiService.updateConnection(editingConnection.id, connectionForm)
			} else {
				await apiService.createConnection(connectionForm)
			}

			await loadConnections()
			setShowModal(false)
			setEditingConnection(null)
		} catch (err) {
			setError('Ошибка при сохранении подключения')
			console.error('Failed to save connection:', err)
		}
	}

	const handleDeleteConnection = async id => {
		if (!window.confirm('Вы уверены, что хотите удалить это подключение?')) {
			return
		}

		try {
			await apiService.deleteConnection(id)
			await loadConnections()
		} catch (err) {
			setError('Ошибка при удалении подключения')
			console.error('Failed to delete connection:', err)
		}
	}

	const truncateText = (text, maxLength = 30) => {
		if (text.length <= maxLength) return text
		return text.substring(0, maxLength) + '...'
	}

	if (loading) {
		return (
			<div>
				<h2>Подключения</h2>
				<div className='loading'>Загрузка подключений...</div>
			</div>
		)
	}

	return (
		<div>
			<h2>Подключения</h2>

			{error && (
				<div className='error-message'>
					{error}
					<button
						onClick={loadConnections}
						style={{ marginLeft: '1rem' }}
						className='button button-secondary'
					>
						Повторить
					</button>
				</div>
			)}

			<div
				className='table'
				style={{
					width: '100%',
					overflowX: 'auto',
					border: '1px solid #e0e0e0',
					borderRadius: '8px',
				}}
			>
				<div
					className='table__row table__row_header'
					style={{
						gridTemplateColumns:
							'minmax(200px, 1fr) minmax(120px, 0.7fr) minmax(150px, 1fr) minmax(150px, 1fr) minmax(200px, 1fr)',
						backgroundColor: '#f5f5f5',
						fontWeight: '600',
					}}
				>
					<div className='table__cell' style={{ padding: '12px 16px' }}>
						Название
					</div>
					<div className='table__cell' style={{ padding: '12px 16px' }}>
						СУБД
					</div>
					<div className='table__cell' style={{ padding: '12px 16px' }}>
						Хост
					</div>
					<div className='table__cell' style={{ padding: '12px 16px' }}>
						База данных
					</div>
					<div className='table__cell' style={{ padding: '12px 16px' }}>
						Действия
					</div>
				</div>

				{connections.length === 0 ? (
					<div className='table__row'>
						<div
							className='table__cell'
							style={{
								padding: '24px 16px',
								textAlign: 'center',
								color: '#666',
								gridColumn: '1 / -1',
							}}
						>
							Нет подключений
						</div>
					</div>
				) : (
					connections.map(connection => (
						<div
							key={connection.id}
							className='table__row'
							style={{
								gridTemplateColumns:
									'minmax(200px, 1fr) minmax(120px, 0.7fr) minmax(150px, 1fr) minmax(150px, 1fr) minmax(200px, 1fr)',
								borderTop: '1px solid #f0f0f0',
								alignItems: 'center',
							}}
						>
							<div className='table__cell' style={{ padding: '12px 16px' }}>
								<span
									className='table__cell_text'
									title={connection.name}
									style={{
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										display: 'block',
									}}
								>
									{connection.name}
								</span>
							</div>
							<div className='table__cell' style={{ padding: '12px 16px' }}>
								<span
									className='table__cell_text'
									style={{
										textTransform: 'capitalize',
										padding: '4px 8px',
										backgroundColor: '#f0f0f0',
										borderRadius: '4px',
										fontSize: '0.9em',
									}}
								>
									{connection.db_type}
								</span>
							</div>
							<div className='table__cell' style={{ padding: '12px 16px' }}>
								<span
									className='table__cell_text'
									title={connection.host}
									style={{
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										display: 'block',
										fontFamily: 'monospace',
										fontSize: '0.9em',
									}}
								>
									{truncateText(connection.host, 40)}
								</span>
							</div>
							<div className='table__cell' style={{ padding: '12px 16px' }}>
								<span
									className='table__cell_text'
									title={connection.database_name}
									style={{
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										display: 'block',
									}}
								>
									{connection.database_name}
								</span>
							</div>
							<div className='table__cell' style={{ padding: '12px 16px' }}>
								<div
									style={{
										display: 'flex',
										gap: '8px',
										flexWrap: 'wrap',
									}}
								>
									<button
										className='button button-small'
										onClick={() => handleEditConnection(connection)}
										style={{
											padding: '6px 12px',
											fontSize: '0.85em',
										}}
									>
										Редактировать
									</button>
									<button
										className='button button-danger button-small'
										onClick={() => handleDeleteConnection(connection.id)}
										style={{
											padding: '6px 12px',
											fontSize: '0.85em',
										}}
									>
										Удалить
									</button>
								</div>
							</div>
						</div>
					))
				)}
			</div>

			<div className='add-section' style={{ marginTop: '24px' }}>
				<button className='button' onClick={handleAddConnection}>
					Добавить подключение
				</button>
			</div>

			<Modal
				isOpen={showModal}
				onClose={() => {
					setShowModal(false)
					setEditingConnection(null)
				}}
				title={
					editingConnection
						? 'Редактирование подключения'
						: 'Добавление подключения'
				}
			>
				<form onSubmit={handleSaveConnection}>
					<div className='form-group'>
						<label>Название подключения:</label>
						<input
							type='text'
							value={connectionForm.name}
							onChange={e =>
								setConnectionForm({ ...connectionForm, name: e.target.value })
							}
							placeholder='editor_datamart_1'
							required
						/>
					</div>

					<div className='form-group'>
						<label>СУБД:</label>
						<select
							value={connectionForm.db_type}
							onChange={e =>
								setConnectionForm({
									...connectionForm,
									db_type: e.target.value,
								})
							}
							required
						>
							<option value=''>Выберите СУБД</option>
							<option value='ClickHouse'>ClickHouse</option>
							<option value='PostgreSQL'>PostgreSQL</option>
							<option value='mysql'>MySQL</option>
						</select>
					</div>

					<div className='form-group'>
						<label>Хост:</label>
						<input
							type='text'
							value={connectionForm.host}
							onChange={e =>
								setConnectionForm({ ...connectionForm, host: e.target.value })
							}
							placeholder='localhost'
							required
						/>
					</div>

					<div className='form-group'>
						<label>Порт:</label>
						<input
							type='number'
							value={connectionForm.port}
							onChange={e =>
								setConnectionForm({ ...connectionForm, port: e.target.value })
							}
							placeholder='5432'
						/>
					</div>

					<div className='form-group'>
						<label>База данных:</label>
						<input
							type='text'
							value={connectionForm.database_name}
							onChange={e =>
								setConnectionForm({
									...connectionForm,
									database_name: e.target.value,
								})
							}
							placeholder='database_name'
						/>
					</div>

					<div className='form-group'>
						<label>Пользователь:</label>
						<input
							type='text'
							value={connectionForm.username}
							onChange={e =>
								setConnectionForm({
									...connectionForm,
									username: e.target.value,
								})
							}
							placeholder='admin'
						/>
					</div>

					<div className='form-group'>
						<label>Описание:</label>
						<textarea
							rows='3'
							value={connectionForm.description}
							onChange={e =>
								setConnectionForm({
									...connectionForm,
									description: e.target.value,
								})
							}
							placeholder='Описание подключения к базе данных'
						/>
					</div>

					<div className='form-group'>
						<label>
							{editingConnection
								? 'Новый пароль (оставьте пустым, если не меняется)'
								: 'Пароль:'}
						</label>
						<input
							type='password'
							value={connectionForm.password}
							onChange={e =>
								setConnectionForm({
									...connectionForm,
									password: e.target.value,
								})
							}
							required={!editingConnection}
						/>
					</div>

					<div className='form-actions'>
						<button
							type='button'
							className='button button-secondary'
							onClick={() => setShowModal(false)}
						>
							Отмена
						</button>
						<button type='submit' className='button'>
							{editingConnection ? 'Сохранить' : 'Добавить'}
						</button>
					</div>
				</form>
			</Modal>

			<style jsx>{`
				.table {
					display: grid;
					min-width: 1000px;
				}

				.table__row {
					display: grid;
					min-height: 60px;
				}

				.table__row:hover {
					background-color: #fafafa;
				}

				.table__cell {
					display: flex;
					align-items: center;
				}

				.table__row_header {
					position: sticky;
					top: 0;
					z-index: 10;
				}

				.button-small {
					min-width: auto;
				}

				@media (max-width: 768px) {
					.table {
						min-width: auto;
						display: block;
					}

					.table__row {
						display: block;
						border-bottom: 1px solid #e0e0e0;
						padding: 16px 0;
					}

					.table__cell {
						display: flex;
						padding: 8px 0;
						justify-content: space-between;
					}

					.table__cell:before {
						content: attr(data-label);
						font-weight: 600;
						margin-right: 16px;
						min-width: 120px;
					}
				}
			`}</style>
		</div>
	)
}

export default Connections
